export function JsonViewer({ parsedJson, level = 0, keyFilter = undefined }: { parsedJson: any, level: number, keyFilter?: string[] | ((key: string) => boolean) }) {
   if (parsedJson === undefined || parsedJson === null) {
      return <></>
   }
   if (Array.isArray(parsedJson)) {
      return parsedJson.filter((a, idx) => idx < 11).map((item, idx) => {
         if (idx === 10) {
            return <div key={idx} style={{ paddingLeft: "2ex", wordBreak: "break-all" }}><p style={{ display: "inline-block", color: "#01019f", margin: "0px" }} >{"! " + (parsedJson.length - 10) + " list items"}</p></div>
         }
         return <div key={idx} style={{ paddingLeft: "2ex", wordBreak: "break-all" }}><p style={{ display: "inline-block", color: "#01019f", margin: "0px" }} >{idx}</p>: <JsonViewer parsedJson={item} level={level + 1} keyFilter={keyFilter} /></div>
      })
   } else if (typeof parsedJson === "object") {
      return Object.keys(parsedJson).filter((a) => {
         if (Array.isArray(keyFilter)) {
            return keyFilter.includes(a)
         } else if (typeof keyFilter === "function") {
            return keyFilter(a)
         }
         return true
      }).map((key) => {
         if (key.includes("technical."))
            return null
         return <div key={key} style={{ paddingLeft: "2ex", wordBreak: "break-all" }}><p style={{ display: "inline-block", color: "#01019f", margin: "0px" }} >{key}</p>: <JsonViewer parsedJson={parsedJson[key]} level={level + 1} keyFilter={keyFilter} /></div>
      })
   } else if (typeof parsedJson === "boolean") {
      return parsedJson ? "true" : "false"
   } else {
      return parsedJson;
   }
}